import HoverSliderHero from '@/components/landing/HoverSliderHero';
import { useReferralTracking } from '@/hooks/useReferralTracking';
import { SEOHead } from '@/hooks/useSEO';
import { getOrganizationSchema } from '@/utils/structuredData';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Landing() {
  useReferralTracking();
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={t('seo.landingTitle')}
        description={t('seo.landingDesc')}
        structuredData={getOrganizationSchema()}
        language={language}
      />
      <HoverSliderHero />
    </div>
  );
}
